import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";

function Footer(props) {
    const location = useLocation();
    const navigate = useNavigate();

    // Khởi tạo các state
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    const [isPlaying, setIsPlaying] = useState(false);
    const [audio, setAudio] = useState(null);
    const [isContactOpen, setIsContactOpen] = useState(false); // State điều khiển đóng/mở khung liên hệ

    // Cấu hình axios
    useEffect(() => {
        const token = localStorage.getItem("user");
        if (token) {
            axios.interceptors.request.use(
                (config) => {
                    config.headers["Authorization"] = `Bearer ${token}`;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        }
    }, []);

    // Lấy cấu hình (setting) từ server
    useEffect(() => {
        if (localStorage.getItem("setting") && localStorage.getItem("setting") !== "undefined") {
            setSetting(JSON.parse(localStorage.getItem("setting")));
        } else {
            axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
                setSetting(res.data.data[0]);
            });
        }
    }, []);

    // Cài đặt âm thanh
    useEffect(() => {
        const mp3Url = localStorage.getItem("mp3");
        if (mp3Url && mp3Url.length > 5) {
            const newAudio = new Audio(mp3Url);
            newAudio.loop = true; 
            setAudio(newAudio);
        } else {
            axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
                if (res.data.data[0]?.mp3) {
                    const newAudio = new Audio(res.data.data[0].mp3);
                    newAudio.loop = true; 
                    setAudio(newAudio);
                    localStorage.setItem("mp3", res.data.data[0].mp3);
                }
            });
        }
        return () => {
            if (audio) {
                audio.pause();
                setAudio(null);
            }
        };
    }, []);

    const toggleAudio = () => {
        if (audio) {
            if (audio.paused) {
                audio.play().then(() => setIsPlaying(true)).catch(e => console.error("Error playing audio:", e));
            } else {
                audio.pause();
                setIsPlaying(false);
            }
        }
    };

    return (
        <>
            <style>{`
                /* ============================================================ */
                /* WIDGET LIÊN HỆ GÓC MÀN HÌNH (POP-OUT) - CSS CẬP NHẬT MÀU ĐỎ */
                /* ============================================================ */
                .kimsa-fixed-contact {
                    position: fixed;
                    right: -280px; /* Ẩn panel lúc đầu */
                    top: 50%;
                    transform: translateY(-50%);
                    display: flex;
                    align-items: center;
                    z-index: 999999;
                    transition: right 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
                }
                .kimsa-fixed-contact.open {
                    right: 0px; /* Trượt ra khi click */
                }

                /* TAB LIÊN HỆ - ĐỔI THÀNH MÀU ĐỎ ĐẬM */
                .kimsa-contact-tab {
                    background: #b00020; /* Màu đỏ đậm phù hợp giao diện */
                    color: #fff;
                    padding: 25px 8px;
                    border-radius: 8px 0 0 8px;
                    cursor: pointer;
                    writing-mode: vertical-rl; /* Chữ dọc */
                    font-size: 16px;
                    font-weight: bold;
                    letter-spacing: 2px;
                    text-transform: uppercase;
                    box-shadow: -4px 4px 10px rgba(0,0,0,0.15);
                    user-select: none;
                }

                /* HỘP PANEL LIÊN HỆ - ĐỔI THÀNH MÀU ĐỎ ĐẬM */
                .kimsa-contact-panel {
                    background: #b00020; /* Màu đỏ đậm */
                    width: 280px;
                    padding: 25px 20px;
                    box-shadow: -2px 5px 15px rgba(0,0,0,0.2);
                    display: flex;
                    flex-direction: column;
                    gap: 18px;
                    border-radius: 0 0 0 8px;
                }

                /* Item Liên Hệ */
                .kimsa-contact-item {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    color: #fff;
                    text-decoration: none;
                    transition: 0.2s;
                }
                .kimsa-contact-item:hover {
                    opacity: 0.8;
                    transform: translateX(-3px);
                    text-decoration: none;
                    color: #fff;
                }
                
                /* Đổi màu icon thành trắng để nổi bật trên nền đỏ */
                .kimsa-contact-icon {
                    width: 28px;
                    height: 28px;
                    object-fit: contain;
                    filter: brightness(0) invert(1); 
                }

                .kimsa-contact-text {
                    display: flex;
                    flex-direction: column;
                    color: #fff;
                }
                .kimsa-contact-title {
                    font-size: 16px;
                    font-weight: normal;
                }
                .kimsa-contact-desc {
                    font-size: 16px;
                    font-weight: normal;
                    margin-top: 2px;
                }

                /* ================================================== */
                /* ĐỊNH DẠNG THANH FOOTER MOBILE (GIỮ NGUYÊN)         */
                /* ================================================== */
                .mobile-footer-wrapper {
                    position: fixed; bottom: 0; left: 50%; transform: translateX(-50%);
                    width: 100%; max-width: 600px; height: 65px;
                    background-color: #2e354d; 
                    display: grid; grid-template-columns: repeat(5, 1fr); 
                    align-items: center; z-index: 9998;
                    box-shadow: 0 -2px 10px rgba(0,0,0,0.3);
                }

                /* Định dạng các nút menu bình thường */
                .footer-item {
                    display: flex; flex-direction: column; align-items: center; justify-content: center;
                    text-decoration: none !important;
                    height: 100%; 
                    color: #6e7a9e; 
                    white-space: nowrap; 
                    font-size: 11px; 
                    transition: 0.3s;
                }
                .footer-item:hover, .footer-item:active, .footer-item:focus {
                    text-decoration: none !important;
                    outline: none;
                }

                .footer-item img {
                    width: 23px; height: 23px; margin-bottom: 4px; object-fit: contain;
                    filter: grayscale(100%) opacity(0.6); transition: 0.3s;
                }
                .footer-item.active { 
                    color: #4a90e2 !important; 
                    text-decoration: none !important;
                }
                .footer-item.active img { filter: grayscale(0%) opacity(1); }

                /* Định dạng nút HOME ở giữa nổi lên */
                .footer-item-center {
                    position: relative; width: 100%; height: 100%; display: flex; justify-content: center;
                }
                
                .ba-home {
                    position: absolute; 
                    left: 50%; 
                    bottom: 18px; 
                    transform: translateX(-50%); 
                    
                    /* Co giãn an toàn cho nút home */
                    width: 15vw;
                    min-width: 63px;
                    max-width: 64px;
                    height: 15vw;
                    min-height: 56px;
                    max-height: 64px;
                    
                    background-image: url('https://dztwieyphe62d.cloudfront.net/content/images/sandsvn/footer/circular.png');
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: 100% 100%; 
                    
                    display: flex; justify-content: center; align-items: center;
                    text-decoration: none !important; z-index: 10000;
                    transition: transform 0.2s;
                }
                .ba-home:hover, .ba-home:active, .ba-home:focus {
                    text-decoration: none !important;
                    outline: none;
                }
                .ba-home:active { transform: translateX(-50%) scale(0.95); }

                .ba-home-icon {
                    position: relative; 
                    z-index: 2; 
                    width: 26px; 
                    height: 26px; 
                    fill: #ffffff;
                    margin-bottom: 2px; 
                }

                body {
                    padding-bottom: 80px;
                }
            `}</style>

            {/* WIDGET POP-OUT LIÊN HỆ (CLICK ĐỂ MỞ TỪ BÊN PHẢI) */}
            <div className={`kimsa-fixed-contact ${isContactOpen ? 'open' : ''}`}>
                <div className="kimsa-contact-tab" onClick={() => setIsContactOpen(!isContactOpen)}>
                    LIÊN HỆ
                </div>
                <div className="kimsa-contact-panel">
                    
                    {/* LiveChat */}
                    <a href="https://secure.livechatinc.com/licence/19707399/v2/open_chat.cgi" target="_blank" rel="noreferrer" className="kimsa-contact-item">
                        <img className="kimsa-contact-icon" src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/livechat.png" alt="LiveChat" />
                        <div className="kimsa-contact-text">
                            <span className="kimsa-contact-title">Liên Hệ</span>
                        </div>
                    </a>

                    {/* Email */}
                    <a href="mailto:info@kimsa88.com" className="kimsa-contact-item">
                        <img className="kimsa-contact-icon" src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/mail.png" alt="Mail" />
                        <div className="kimsa-contact-text">
                            <span className="kimsa-contact-title">E-mail</span>
                            <span className="kimsa-contact-desc">info@kimsa88.net</span>
                        </div>
                    </a>

                    {/* Đường kẻ phân cách (được cập nhật màu đỏ mờ) */}
                    <div style={{ height: "1px", background: "rgba(255, 0, 0, 0.3)", margin: "5px 0" }}></div>

                
                    {/* Tải App */}
                    {setting?.down_link && (
                        <a href={setting.down_link} target="_blank" rel="noreferrer" className="kimsa-contact-item">
                            <div style={{ width: "28px", textAlign: "center", fontWeight: "bold", color: "#fff" }}>APP</div>
                            <div className="kimsa-contact-text">
                                <span className="kimsa-contact-title">Tải App Về Máy</span>
                            </div>
                        </a>
                    )}
                </div>
            </div>

            {/* THANH FOOTER MOBILE */}
            <footer className="mobile-footer-wrapper">
                <Link to="/recharge/bank" className={`footer-item ${location.pathname === '/recharge/bank' ? 'active' : ''}`}>
                    <img src="https://dztwieyphe62d.cloudfront.net/content/images/sandsvn/footer/deposit.png" alt="Nạp tiền" />
                    <span>Nạp tiền</span>
                </Link>

                <Link to="/withdraw" className={`footer-item ba-left ${location.pathname === '/withdraw' ? 'active' : ''}`}>
                    <img src="https://dztwieyphe62d.cloudfront.net/content/images/sandsvn/footer/draw.png" alt="Rút tiền" />
                    <span>Rút tiền</span>
                </Link>

                <div className="footer-item-center">
                    <Link to="/" className="ba-home" onClick={() => { if(props.resetHome) props.resetHome(); setIsContactOpen(false); }}>
                        <svg className="ba-home-icon" viewBox="0 0 24 24">
                            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
                        </svg>
                    </Link>
                </div>

                <Link to="/notification" className={`footer-item ba-right ${location.pathname === '/notification' ? 'active' : ''}`}>
                    <img src="https://dztwieyphe62d.cloudfront.net/content/images/sandsvn/footer/promo.png" alt="Khuyến mãi" />
                    <span>Khuyến mãi</span>
                </Link>

                <Link to="/profile" className={`footer-item ${location.pathname === '/profile' ? 'active' : ''}`}>
                    <img src="https://dztwieyphe62d.cloudfront.net/content/images/sandsvn/footer/user.png" alt="Hồ sơ" />
                    <span>Hồ sơ</span>
                </Link>
            </footer>
        </>
    );
}

export default Footer;